module.exports = __webpack_public_path__ + "img/2.f4d9c117.jpg";